import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Threetwoseaterbusonrentfornashik() {



const cardData =
{
  keyword: '32 Seater Bus on Rent for Nashik Darshan',
  heading: 'Sanavi Travels: 32 Seater Bus on Rent for Nashik Darshan',
  headingDescription: 'Sanavi Travels offers reliable, comfortable, and professionally managed 32 Seater Bus on Rent for Nashik Darshan, specially designed for religious groups, families, senior citizens, corporate spiritual tours, wedding groups, and large pilgrimage mandals traveling from Pune and nearby regions to Nashik. Nashik is one of Maharashtra’s most important religious destinations, known for Trimbakeshwar Jyotirlinga, Kalaram Temple, Panchavati, Sita Gufa, Ramkund, and other sacred sites, often requiring well-planned group transportation for a smooth darshan experience. Our 32 seater buses are ideal for medium to large groups who want to travel together comfortably without the hassle of managing multiple vehicles.',

  top: 'Popular Nashik Darshan Experiences with 32 Seater Bus',

  topPlaces: [
    {
      title: 'Trimbakeshwar Jyotirlinga Darshan',
      description: 'Trimbakeshwar is one of the most sacred Jyotirlingas of Lord Shiva and a key highlight of Nashik Darshan. Traveling in a 32 seater bus allows the entire group to arrive together, maintain discipline during darshan, and avoid travel fatigue during the long journey.'
    },
    {
      title: 'Panchavati Religious Circuit',
      description: 'Panchavati includes Ramkund, Kalaram Temple, Sita Gufa, and Kapaleshwar Temple. A 32 seater bus makes it easy for groups to cover multiple temples in a planned sequence without worrying about parking or coordination.'
    },
    {
      title: 'Ramkund & Kalaram Temple Visit',
      description: 'Ramkund and Kalaram Temple are central to Nashik’s spiritual identity. Group travel by bus ensures smooth entry, safe parking, and relaxed movement between nearby temples.'
    },
    {
      title: 'Senior Citizen Darshan Tours',
      description: 'Pushback seating, stable ride quality, and professional driving make 32 seater buses suitable for senior citizens undertaking Nashik Darshan.'
    },
    {
      title: 'Family Pilgrimage Travel',
      description: 'Large families prefer 32 seater buses to travel together, share devotional moments, and avoid splitting into multiple vehicles.'
    },
    {
      title: 'Group & Mandal Yatra',
      description: 'Religious mandals and community groups benefit from traveling together in a single bus, ensuring unity, discipline, and smooth darshan planning.'
    },
    {
      title: 'Wedding Family Religious Trips',
      description: 'Wedding families often visit Nashik temples before or after ceremonies. A 32 seater bus simplifies guest transportation and scheduling.'
    },
    {
      title: 'Corporate Spiritual Tours',
      description: 'Companies organizing spiritual retreats or employee religious tours use 32 seater buses for comfortable and organized group travel.'
    },
    {
      title: 'One Day Nashik Darshan',
      description: 'For one-day Nashik Darshan from Pune, a 32 seater bus ensures timely departure, planned sightseeing, and safe return.'
    },
    {
      title: 'Multi-Day Nashik Pilgrimage',
      description: 'For extended stays, a 32 seater bus supports overnight halts, luggage management, and relaxed multi-day travel.'
    }
  ],

  services: [
    {
      name: '32 Seater Bus on Rent for Nashik Darshan',
      description: 'Sanavi Travels provides dedicated 32 seater bus rental services for complete Nashik Darshan, ensuring safe, comfortable, and well-coordinated pilgrimage travel for medium and large groups.'
    },
    {
      name: 'AC 32 Seater Bus Nashik',
      description: 'AC 32 seater buses offer a cool and comfortable environment, ideal for long-distance darshan travel and summer seasons.'
    },
    {
      name: 'Non AC 32 Seater Bus Nashik',
      description: 'Non AC 32 seater buses provide an economical option for religious groups while maintaining safety and seating comfort.'
    },
    {
      name: 'Luxury 32 Seater Bus Nashik',
      description: 'Luxury buses feature premium interiors, smooth suspension, and enhanced comfort for senior citizens and premium darshan tours.'
    },
    {
      name: '32 Seater Bus for Family Nashik',
      description: 'Family-friendly buses ensure relaxed travel for all age groups during Nashik Darshan.'
    },
    {
      name: '32 Seater Bus for Corporate Nashik',
      description: 'Corporate spiritual tours benefit from punctual, professional, and organized bus travel.'
    },
    {
      name: '32 Seater Bus for Group Nashik',
      description: 'Group travel in a single bus improves coordination, safety, and devotional focus.'
    },
    {
      name: 'Affordable 32 Seater Bus Rental Nashik',
      description: 'We offer cost-effective rental packages without compromising comfort or reliability.'
    },
    {
      name: 'Best 32 Seater Bus Service Nashik',
      description: 'Sanavi Travels is known for dependable service, clean vehicles, and experienced drivers.'
    },
    {
      name: '32 Seater Bus with Driver Nashik',
      description: 'All rentals include trained drivers familiar with Nashik routes, temples, and highway travel.'
    },
    {
      name: '32 Seater Bus for Wedding Nashik',
      description: 'Wedding-related religious travel is managed smoothly with coordinated bus schedules.'
    },
    {
      name: '32 Seater Bus for Picnic Nashik',
      description: 'Groups combining darshan with leisure trips can travel comfortably in a single bus.'
    },
    {
      name: 'Outstation 32 Seater Bus Nashik',
      description: 'Outstation bus services ensure relaxed long-distance travel with planned breaks.'
    },
    {
      name: '32 Seater Bus for Tour Nashik',
      description: 'Tour packages covering temples and nearby attractions are easily managed with a 32 seater bus.'
    }
  ],

  tableData: [
    ['32 Seater Bus Nashik Darshan', 'AC 32 Seater Bus'],
    ['Non AC 32 Seater Bus', 'Luxury Bus'],
    ['Family Travel', 'Group Yatra'],
    ['Corporate Tours', 'Wedding Travel'],
    ['One Day Trip', 'Multi-Day Tour']
  ],

  whychoose: [
    { WhyChooseheading: 'Experienced Darshan Drivers', WhyChoosedescription: 'Drivers familiar with Nashik temples, highways, and ghat routes.' },
    { WhyChooseheading: 'Comfortable Seating', WhyChoosedescription: 'Pushback seats and ample legroom for long journeys.' },
    { WhyChooseheading: 'Well-Maintained Buses', WhyChoosedescription: 'Clean, sanitized, and safety-checked vehicles.' },
    { WhyChooseheading: 'Flexible Travel Plans', WhyChoosedescription: 'One-day and multi-day darshan packages available.' },
    { WhyChooseheading: 'Transparent Pricing', WhyChoosedescription: 'No hidden charges or last-minute costs.' },
    { WhyChooseheading: 'Group-Friendly Travel', WhyChoosedescription: 'Entire group travels together peacefully.' },
    { WhyChooseheading: 'Senior Citizen Friendly', WhyChoosedescription: 'Smooth rides and patient driving style.' },
    { WhyChooseheading: 'Trusted Pilgrimage Partner', WhyChoosedescription: 'Sanavi Travels is known for reliable religious tours.' }
  ]
};

const faqData = [
  { question: 'Do you provide 32 seater bus on rent for Nashik Darshan?', answer: 'Yes, Sanavi Travels offers 32 seater bus rental for complete Nashik Darshan.' },
  { question: 'Are AC buses available for Nashik Darshan?', answer: 'Yes, both AC and Non AC 32 seater buses are available.' },
  { question: 'Is the service suitable for senior citizens?', answer: 'Yes, our buses and drivers are senior-citizen friendly.' },
  { question: 'Can we plan a one-day Nashik Darshan?', answer: 'Yes, one-day and multi-day darshan packages are available.' },
  { question: 'Are drivers experienced with Nashik temple routes?', answer: 'Yes, our drivers are familiar with all major Nashik darshan routes.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended, especially during peak seasons.' },
  { question: 'Do you provide pickup from Pune?', answer: 'Yes, pickup is available from Pune and nearby areas.' },
  { question: 'Are buses cleaned before travel?', answer: 'Yes, all buses are cleaned and safety-checked before departure.' },
  { question: 'Do you offer affordable group packages?', answer: 'Yes, we provide budget-friendly darshan travel packages.' },
  { question: 'Can the itinerary be customized?', answer: 'Yes, itineraries can be customized based on group requirements.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikas Kulkarni',
    feedback: 'Our Nashik Darshan in a 32 seater bus was very comfortable and well-managed. Excellent service by Sanavi Travels.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sunita Patil',
    feedback: 'Clean bus, polite driver, and smooth darshan planning. Highly recommended for group travel.',
    rating: 5
  }
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32 Seater Bus on Rent for Nashik Darshan - Sanavi Travels",
  "description": "Sanavi Travels offers 32-seater buses on rent for Nashik Darshan trips, including family travel, corporate trips, group tours, weddings, picnics, outstation travel, and tour packages. AC and Non-AC options, luxury buses, and mini buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};










  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | 32 Seater Bus on Rent for Nashik Darshan | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 32-seater buses for Nashik Darshan with Sanavi Travels. AC & Non-AC luxury buses, mini buses for family trips, corporate travel, group tours, weddings, picnics, outstation travel, and tour packages with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/284.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Threetwoseaterbusonrentfornashik;